"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/components/SignupStepWrapper/NavItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _AuthFrame = require('web/components/AuthFrame');















const SignupStepNavItem = ({
  index, name, lowerBound, upperBound, currentStep, maxStep, gotoStep,
}) => {
  const isCompleted = currentStep > upperBound
  const isActive = currentStep >= lowerBound && currentStep <= upperBound
  // An active multi-step group is clickable past its first step: e.g. the
  // trial offer sits inside "Plan & agreements", and clicking the label there reads
  // as "back to plan selection".
  const canRewindWithinGroup = isActive && currentStep > lowerBound
  const isClickable = !!gotoStep &&
    (isCompleted || canRewindWithinGroup || (!isActive && maxStep >= lowerBound))
  // Backward jumps land on the group's first step (unchanged behavior);
  // forward jumps land on the furthest visited step within the group.
  const target = isCompleted || canRewindWithinGroup
    ? lowerBound
    : Math.min(maxStep, upperBound)

  const className = _classBuilder2.default.call(void 0, 
    "signup-step--nav-item",
    isCompleted && "signup-step--nav-item--completed",
    isActive && "signup-step--nav-item--active",
  )
  const content = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('span', { className: "signup-step--nav-item--badge", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        ,  isCompleted ? _react2.default.createElement(_AuthFrame.CheckIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} ) : index 
      )
      , _react2.default.createElement('span', { className: "signup-step--nav-item--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}},  name )
    )
  )

  return isClickable
    ? (
        _react2.default.createElement('button', { type: "button", className: className, onClick: () => _optionalChain([gotoStep, 'optionalCall', _ => _(target)]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
          ,  content 
        )
      )
    : (
        _react2.default.createElement('div', { className: className, 'aria-current': isActive ? 'step' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          ,  content 
        )
      )
}

exports. default = SignupStepNavItem
